import React, {useMemo, useState} from 'react';
import {Map, Placemark, YMaps} from "@pbe/react-yandex-maps";
import styles from "./ContactsMap.module.css";
import {CircleLoader} from "react-spinners";

const ContactsMap = () => {

    const defaultState = useMemo(() => {
        return {
            center: [55.741338, 37.620555],
            zoom: 16
        }
    }, []);

    const [isLoadingMap, setIsLoadingMap] = useState<boolean>(true)


    return (
        <YMaps>
            {isLoadingMap ? <div className={styles.loadingMapWrapper}><CircleLoader color="#B29E7D" /> </div>: null}
            <Map  onLoad={() => setIsLoadingMap(false)} defaultState={defaultState} className={styles.yandexMap}>
                <Placemark geometry={[55.741338, 37.620555]} />
            </Map>
        </YMaps>
    );
};

export default ContactsMap;